// extracted by mini-css-extract-plugin
module.exports = {"fondo":"SliderDocument__fondo__3cEcS","fondo2":"SliderDocument__fondo2__3UZT5","fondo3":"SliderDocument__fondo3__2a9eG","fondoCuotas":"SliderDocument__fondoCuotas__T8RtV"};